import React, { useRef } from 'react';

import { format } from 'date-fns';
import { Formik } from 'formik';
import { Form, FormGroup } from 'react-bootstrap';
import { object, array, string, date } from 'yup';

import Style from './Education.module.css';

import { Button } from '../../../atoms';

import { isEmpty } from '../../../../utils/generic';

function Education({ userDetails, setSection, seteducation, parsedData, fillViaResume, education }) {
  const handleBtnSubmit = (values) => {
    seteducation(values);
    setSection({ value: 'Professional Details', id: 3 });
  };

  const handleBack = (values) => {
    seteducation(values);
    setSection({ value: 'Work Details', id: 1 });
  };

  const parsedEducation = parsedData?.education?.map((ele) => ({
    degree: ele?.degree,
    institute: ele?.college,
    start_date: ele?.start_date,
    end_date: ele?.end_date
  }));

  const listEndRef = useRef(null);

  const scrollToBottom = () => {
    listEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={{
          // education_details: !isEmpty(userDetails?.education_details) ? userDetails?.education_details : [{degree: '', institute: '', start_date: '', end_date: ''}],

          education_details: fillViaResume
            ? !isEmpty(parsedData?.education)
              ? parsedEducation
              : [{ degree: '', institute: '', start_date: '', end_date: '' }]
            : !isEmpty(education?.education_details)
              ? education?.education_details
              : !isEmpty(userDetails?.education_details)
                ? userDetails?.education_details
                : [{ degree: '', institute: '', start_date: '', end_date: '' }]
        }}
        onSubmit={(values) => {
          handleBtnSubmit(values);
        }}
        validationSchema={object().shape({
          education_details: array()
            .of(
              object().shape({
                degree: string().required('Required'),
                institute: string().required('Required'),
                start_date: date().required('Required'),
                end_date: date().required('Required')
              })
            )
            .required('Required')
        })}
      >
        {({ values, isSubmitting, setFieldTouched, handleSubmit, errors, touched, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <div className={`${Style.BasicDetailsEdit} ${Style.WorkContainer}`}>
              {values.education_details?.map((item, i) => (
                <div key={i}>
                  <FormGroup className='row margin-0'>
                    <div className='col-12 padding0L padding0R'>
                      <label className={`${Style.smallHeading} ${Style.greyColor2} padding16T`} htmlFor={'degree' + i}>
                        Degree<span>*</span>
                      </label>
                      <input
                        className={Style.inputBoxEditable}
                        data-testid={'degree' + i}
                        id={'degree' + i}
                        name='degree'
                        onBlur={() => setFieldTouched(`education_details[${i}].degree`, true)}
                        onChange={(e) => setFieldValue(`education_details[${i}].degree`, e.target.value)}
                        value={item.degree}
                      />
                      {errors.education_details?.[i]?.degree && touched.education_details?.[i]?.degree ? (
                        <div className='font-12px red'>{errors.education_details[i].degree}</div>
                      ) : null}
                    </div>
                    <div className='col-12 padding0L padding0R'>
                      <label className={`${Style.smallHeading} ${Style.greyColor2} padding16T`} htmlFor={'institute' + i}>
                        School/College/University Name <span>*</span>
                      </label>
                      <input
                        className={Style.inputBoxEditable}
                        data-testid={'institute' + i}
                        id={'institute' + i}
                        name='institute'
                        onBlur={() => setFieldTouched(`education_details[${i}].institute`, true)}
                        onChange={(e) => setFieldValue(`education_details[${i}].institute`, e.target.value)}
                        value={item.institute}
                      />
                      {errors.education_details?.[i]?.institute && touched.education_details?.[i]?.institute ? (
                        <div className='font-12px red'>{errors.education_details[i].institute}</div>
                      ) : null}
                    </div>
                  </FormGroup>
                  <FormGroup className='row margin-0'>
                    <div className='col-12 padding0L padding0R'>
                      <label className={`${Style.smallHeading} ${Style.greyColor2} padding16T`} htmlFor={'start_date' + i}>
                        Start Date<span>*</span>
                      </label>
                      <input
                        className={Style.inputBoxEditable}
                        data-testid={'start_date' + i}
                        id={'start_date' + i}
                        max={item.end_date?.split(' ')[0] || format(new Date(), 'yyyy-MM-dd')}
                        min='1900-01-01'
                        name='start_date'
                        onBlur={() => setFieldTouched(`education_details[${i}].start_date`, true)}
                        onChange={(e) => setFieldValue(`education_details[${i}].start_date`, e.target.value)}
                        type='date'
                        value={item.start_date?.split(' ')[0]}
                      />
                      {errors.education_details?.[i]?.start_date && touched.education_details?.[i]?.start_date ? (
                        <div className='font-12px red'>{errors.education_details[i].start_date}</div>
                      ) : null}
                    </div>
                    <div className='col-12 padding0L padding0R'>
                      <label className={`${Style.smallHeading} ${Style.greyColor2} padding16T`} htmlFor={'end_date' + i}>
                        End Date<span>*</span>
                      </label>
                      <input
                        className={Style.inputBoxEditable}
                        data-testid={'end_date' + i}
                        id={'end_date' + i}
                        max={format(new Date(), 'yyyy-MM-dd')}
                        min={item.start_date?.split(' ')[0]}
                        name='end_date'
                        onBlur={() => setFieldTouched(`education_details[${i}].end_date`, true)}
                        onChange={(e) => setFieldValue(`education_details[${i}].end_date`, e.target.value)}
                        type='date'
                        value={item.end_date?.split(' ')[0]}
                      />
                      {errors.education_details?.[i]?.end_date && touched.education_details?.[i]?.end_date ? (
                        <div className='font-12px red'>{errors.education_details[i].end_date}</div>
                      ) : null}
                    </div>
                  </FormGroup>
                  {values?.education_details?.length > 1 ? (
                    <div className='col-12 text-right font-14px red'>
                      <span
                        className='pointer'
                        onClick={() => {
                          const updated_details = values.education_details.filter((_, index) => i !== index);

                          setFieldValue('education_details', updated_details);
                        }}
                      >
                        Remove
                      </span>
                    </div>
                  ) : null}
                  {i !== values.education_details.length - 1 ? <div className='border-gray-dash my-4' /> : null}
                </div>
              ))}
              <div ref={listEndRef} />
            </div>
            <FormGroup className={`m-t-20 ${Style.WorkContainer}`}>
              <Button
                className='general-outline-style full-width-imp paddingTop'
                disabled={isSubmitting}
                onClick={() => {
                  const newExp = { company_name: '', designation: '', start_date: '', end_date: '' };

                  setFieldValue('education_details', [...values.education_details, newExp]);
                  setTimeout(() => {
                    scrollToBottom();
                  }, 500);
                }}
                type='button'
              >
                + Add Another Education Details
              </Button>
            </FormGroup>
            <div className={`${Style.bottomFixedBtns} flexStyleStart`}>
              <Button className='general-outline-style paddingTop flex-style-center align-items-center' onClick={() => handleBack(values)} type='button'>
                Back
              </Button>
              <Button className='general-style' data-testid='education-next-button' type='submit'>
                Next
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default Education;
